import { useEffect, useState } from "react";

// STYLES
import * as Style from "./EditPromoCodeStyle";

// LIBRARIES

// MISC
import { COLORS } from "constants/styleVariables";
import {
  ButtonTypes
} from "models/GeneralTypes/generalTypes";
import { IEditPromoCode } from "models/interfaces";
import { IModalData, IProps } from "./EditPromoCodeModel";

// ASSETS
import ClockIcon from "assets/Icons/TimeIcon.svg";
import PersonDefaultIcon from "assets/Icons/defaultPersonPhoto.jpg";

// REDUX
import { editPromoCode, getPromoCodeUsers } from "api/promoCodeApi";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import dayjs from "dayjs";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { modalProps, toggleModalState } from "slices/uiSlice";

// COMPONENTS

const EditPromoCode = (props: IProps) => {
  // PROPS
  const { handleClose = () => { } } = props;

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const modalPropsData = useAppSelector<IModalData>(modalProps);

  // CONSTANTS USING HOOKS
  const [promoCodeData, setPromoCodeData] = useState(modalPropsData?.promoCode);
  const [promoCodeUsers, setPromoCodeUsers] = useState([]);
  const [isValid, setIsValid] = useState(modalPropsData?.promoCode?.isValid);

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    if (promoCodeData.type === "NOMINAL") {
      dispatch(getPromoCodeUsers(promoCodeData.id))
        .unwrap()
        .then((response) => {
          console.log(response)
          setPromoCodeUsers(response);
        })
    }
  }, [promoCodeData]);

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS

  const handleEditPromoCode = () => {
    let payload: IEditPromoCode = {
      isValid: isValid,
      promoCodeId: promoCodeData.id
    }
    dispatch(editPromoCode(payload))
      .unwrap()
      .then((resp) => {
        console.log(resp)
        handleCloseModal()
      })
  }

  const handleCloseModal = () => {
    dispatch(
      toggleModalState({
        isVisible: false,
        type: "",
      })
    );
  }

  return (
    <Style.DoorDetailsContainer type={promoCodeData.type}>
      <Style.CloseIconContainer>
        <Style.CloseIcon onClick={handleClose} />
      </Style.CloseIconContainer>
      <Style.Title color={COLORS.terraCotta}>
        Edit Status
      </Style.Title>
      <Style.InfoWrapper>
        <Style.PromoCodeInfo>
          <Style.FirstInfoRow>
            <Style.NotificationTitle>
              {promoCodeData.code}
              <Style.PromoCodeStatus>
                {`Promo ${isValid === true ? "active" : "inactive"}`}
              </Style.PromoCodeStatus>
            </Style.NotificationTitle>
            <Style.NotificationDateContainer>
              <Style.ClockIconImage src={ClockIcon} />
              <Style.NotificationDate>
                {dayjs("2023-06-15T19:13:28.195+00:00").format(
                  "HH:mm DD.MM.YYYY"
                )}{" "}
              </Style.NotificationDate>
            </Style.NotificationDateContainer>
          </Style.FirstInfoRow>
          <Style.PromoCodeType>
            {promoCodeData.type === "GLOBAL" ? "Global Usage" : "Nominal Usage"}
          </Style.PromoCodeType>
        </Style.PromoCodeInfo>
        <Style.InfoLine>
          <Style.Info>
            Promo-code type
          </Style.Info>
          <Style.Value>
            {promoCodeData.discountType === "FIXED" ? "Fixed dicount" : "Percentage"}
          </Style.Value>
        </Style.InfoLine>

        <Style.InfoLine>
          <Style.Info>
            The amount
          </Style.Info>
          <Style.Value>
            {promoCodeData.discountType === "FIXED" ? `${promoCodeData.amount} RON` : `${promoCodeData.amount}%`}
          </Style.Value>
        </Style.InfoLine>

        {promoCodeData.type === "NOMINAL" &&
          <>
            <Style.Info>
              Users that have this promo-code
            </Style.Info>
            <Style.UsersList>
              {promoCodeUsers &&
                promoCodeUsers.map((user, index) => {
                  return (
                    <Style.UserContainer>
                      <Style.UserIcon src={PersonDefaultIcon} />
                      <Style.UserName>
                        {user?.fullName || "NO_NAME_PROVIDED"}
                      </Style.UserName>
                    </Style.UserContainer>
                  )
                })
              }
            </Style.UsersList>
          </>
        }

        <Style.ChangeStatusWrapper>
          <Style.Info>
            Change the status of the promo code
          </Style.Info>
          <ButtonAtom
            text={isValid ? "Disable" : "Enable"}
            type={ButtonTypes.OUTLINED_BUTTON}
            onClick={() => { setIsValid(!isValid) }}
          />
        </Style.ChangeStatusWrapper>
      </Style.InfoWrapper>

      <Style.ButtonContainer>
        <ButtonAtom
          text={"Salveaza"}
          type={ButtonTypes.MAIN_BUTTON}
          onClick={() => handleEditPromoCode()}
          width="169px"
        />
      </Style.ButtonContainer>



    </Style.DoorDetailsContainer>
  );
};

export default EditPromoCode;
